export default __webpack_public_path__ + "static/media/102.7334f98f.png";